module.exports = __webpack_public_path__ + "static/media/jekyllrb.236d4c44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/jekyllrb.png
// module id = 124
// module chunks = 0